import { FeaturedContent } from '@chemist4u/newt-components';
import { storeName } from '@lib/config/brand';
import { composeThemeToken } from '@lib/mappers';

const SkeletonProductCard = () => (
  <div className="flex h-full w-full flex-col nw-rounded-card nw-bg-card border nw-border-card">
    <div className="aspect-square w-full nw-rounded-tl-card nw-rounded-tr-card bg-gray-100" />
    <div className="flex flex-1 flex-col justify-between nw-gap-tight nw-px-tight nw-py-tight">
      <div className="h-4 w-3/4 rounded bg-gray-100" />
      <div className="h-5 w-1/3 rounded bg-gray-100" />
    </div>
  </div>
);

export default function SkeletonProductSlider() {
  return (
    <FeaturedContent
      layout="carousel"
      heading={{
        tag: 'h2',
        children: 'Explore Our Most Popular Treatments',
      }}
      subtext="Find the right treatment for you."
      theme={composeThemeToken(storeName, 'neutral-subtle')}
      contentClassName="animate-pulse"
    >
      {Array.from({ length: 4 }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton, index is stable
        <SkeletonProductCard key={i} />
      ))}
    </FeaturedContent>
  );
}
